import styled from 'styled-components';
import {device} from '../../styled/device';
import Modal from '../Modal';
import QuestionMarkButton from '../QuestionMarkButton';

export const Form = styled.form`
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (max-width: ${device.tablet}) {
    margin: 20px 0 0;
  }
  @media (min-width: 760px) and (max-width: 770px) {
    margin: 20px 0 0;
  }
`;

type FieldsProps = {
  rowsCount: number;
};

export const Fields = styled.div<FieldsProps>`
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 50px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(${props => props.rowsCount}, auto);
  text-align: center;
  max-width: 778px;
  position: relative;

  @media (max-width: ${device.laptop}) {
    grid-column-gap: 84px;
  }

  @media (max-width: ${device.tablet}) {
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    display: flex;
  }
`;

export const SendingDataModal = styled(Modal)`
  & .popup-content {
    background: #fbfbfb !important;
  }

  & .icon-modal {
    margin-top: 30px;
  }

  & .modal_title {
    max-width: 260px;
  }
`;

export const InvalidFileTypeError = styled.div`
  font-family: inherit;
  text-align: right;
  color: #f84b7a;
  font-size: 12px;
`;

export const IncompleteModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  max-width: 400px;
  height: 400px;

  .title {
    font-size: 24px;
  }

  .text {
    font-size: 18px;
  }
  .modalButtons {
    margin-bottom: 67px;
  }
`;

// export const CheckboxWrapper = styled.div`
//   max-width: 319px;
//   margin: 60px auto 0;

//   @media (max-width: ${device.tablet}) {
//     margin: 30px auto 0;
//   }

//   @media (max-width: ${device.mobileS}) {
//     max-width: unset;
//     margin-left: 10px;
//   }
// `;

// export const TermsLink = styled.a`
//   color: #1a8cff;
//   font-family: ProximaNova-Bold, sans-serif;
//   font-size: 18px;
//   text-decoration: none;

//   &:hover {
//     opacity: 0.9;
//   }

//   &:active {
//     opacity: 1;
//   }
// `;

// export const ModalButtonWrapper = styled.div`
//   text-align: center;
//   margin-bottom: 52px;

//   & > button {
//     margin: auto;
//   }
// `;

export const FieldQuestionMarkButton = styled(QuestionMarkButton)`
  height: 22px;
  width: 22px;

  & > img {
    width: 100%;
    height: 100%;
  }

  &:active {
    opacity: 0.8;
  }
`;

export const TooltipTrigger = styled.div`
  position: relative;
  z-index: 2;
  padding-left: 5px;
`;
